import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Modal,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconEdit from "../../assets/images/product/edit.svg";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import iconBack from "../../assets/images/quailai.svg";
import iconArrowLeft from "../../assets/images/arrow-left.svg";
import { AiOutlineMore } from "react-icons/ai";
import SearchableSelect from "../../components/selectForm";
import { useCategories } from "../../categorys/locking/index";
import toast from "react-hot-toast";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import { useStepCommission } from "../../hooks/useStepCommission";
import { useNavigate } from "react-router-dom";
import { stepCommissionCall } from "../../api/stepCommission";
import { delay, formatNumberUS, formatPriceUS } from "../../utils/utils";
import iconPlus2 from "../../assets/images/personnelCategories/plus.svg";
import {
  InputControl,
  InputDatePicker,
  SelectControl,
} from "../../components/form/formControls";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm, useWatch } from "react-hook-form";
import { usePaymentServiceFee } from "../../hooks/usePaymentServiceFee";
import DeleteDialog from "../../components/dialog/delete";
import IconX from "../../assets/images/booking/x-circle.svg";
import {
  currentDateHourDb,
  currentformatDateDb,
  formatDateDb,
  formatDateHourDb,
} from "../../utils/tools";

const schemaPaymentPeriod = Yup.object().shape({
  id: Yup.string().required("mã đợt thanh toán là bắt buộc"),
  lockingId: Yup.string().required("mã đợt locking là bắt buộc"),
  // period: Yup.number()
  //   .nullable()
  //   .transform((value, originalValue) => {
  //     if (typeof originalValue === "string") {
  //       return originalValue.trim() === "" ? null : Number(originalValue);
  //     }
  //     return originalValue === null ? null : Number(originalValue);
  //   })
  //   .required("Số đợt là bắt buộc"),
  periodPayment: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Số đợt thanh toán là bắt buộc"),
  paymentPercent: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .required("Phần trăm đợt thanh toán là bắt buộc"),
});

export default function PaymentPeriodForm({
  id,
  lockingId,
  period,
  periodPayment,
  paymentPercent,
  refetchParent,
  getInfomationStepCommission,
  listEmployee = [],
  isFake,
  deleteHandler,
  setOpenIndex,
  accordionRef,
  paymentPeriods,
  step,
}) {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const {
    isOpen: isOpenEditPrice,
    onOpen: onOpenEditPrice,
    onClose: onCloseEditPrice,
  } = useDisclosure();
  const {
    isOpen: isOpenBreakdown,
    onOpen: onOpenBreakdown,
    onClose: onCloseBreakdown,
  } = useDisclosure();
  const {
    isOpen: isOpenDeleteFee,
    onOpen: onOpenDeleteFee,
    onClose: onCloseDeleteFee,
  } = useDisclosure();
  // Dòng nhân viên đang chờ xác nhận xoá khỏi đợt thanh toán.
  const [feeToDelete, setFeeToDelete] = useState(null);
  const [breakdownInfo, setBreakdownInfo] = useState(null);
  const [search, setSearch] = useState("");
  const [shouldFetch, setShouldFetch] = useState(false);
  const [listPaymentService, setListPaymentService] = useState([]);
  const [dataEdit, setDataEdit] = useState(null);

  /**
   * Xoá 1 dòng nhân viên khỏi đợt thanh toán. BE tự tính lại tổng của đợt, số còn
   * lại của NV và tổng của căn, nên FE chỉ cần load lại dữ liệu.
   */
  const onSubmitDeleteFee = async () => {
    if (!feeToDelete?.id) return;
    try {
      const res = await stepCommissionCall.deletePaymentServiceFee(
        feeToDelete.id
      );
      if (res) {
        toast.success("Xóa nhân viên khỏi đợt thanh toán thành công");
        onCloseDeleteFee();
        setFeeToDelete(null);
        setShouldFetch((prev) => !prev);
        if (refetchParent) refetchParent();
        if (getInfomationStepCommission) {
          getInfomationStepCommission(lockingId);
        }
      }
    } catch (error) {
      console.error("Delete payment service fee error:", error);
    }
  };

  const [zIndex, setZIndex] = useState("");
  const [focusStates, setFocusStates] = useState({});
  const handleFocus = (field, data) => {
    if (data) {
      setZIndex(data);
    }
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };
  const handleBlur = (field, data) => {
    setZIndex("");
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    lockingManagementData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = usePaymentServiceFee(
    debouncedSearchTerm,
    lockingId,
    period,
    periodPayment,
  );

  // Sửa Ngày thanh toán / Tháng ĐC của đợt đã lưu (chỉ đổi thông tin, không đổi
  // số tiền). infoMonths: mỗi Tháng ĐC hiện có -> { from: "MM/YYYY", to: Date }.
  const [isEditInfo, setIsEditInfo] = useState(false);
  const [infoDate, setInfoDate] = useState(null);
  const [infoMonths, setInfoMonths] = useState([]);

  const openEditInfo = () => {
    const baseDate = step?.disbursementDate || step?.createdAt;
    setInfoDate(baseDate ? new Date(baseDate) : new Date());
    const months = step?.monthYears?.length ? step.monthYears : [""];
    setInfoMonths(
      months.map((m) => {
        const [month, year] = (m || "").split("/").map(Number);
        return { from: m, to: month && year ? new Date(year, month - 1, 1) : null };
      }),
    );
    setIsEditInfo(true);
  };

  const submitEditInfo = async () => {
    if (!infoDate) {
      toast.error("Vui lòng chọn ngày thanh toán");
      return;
    }
    if (step?.monthYears?.length && infoMonths.some((m) => !m.to)) {
      toast.error("Vui lòng chọn tháng đối chiếu");
      return;
    }
    const toastUpdate = toast.loading("Đang sửa ngày thanh toán ...");
    try {
      await stepCommissionCall.updatePaymentPeriodInfo(id, {
        disbursementDate: formatDateDb(infoDate, 1),
        monthYears: infoMonths
          .filter((m) => m.to)
          .map((m) => ({
            from: m.from,
            to: `${String(m.to.getMonth() + 1).padStart(2, "0")}/${m.to.getFullYear()}`,
          })),
      });
      await refetch();
      await getInfomationStepCommission(lockingId);
      setIsEditInfo(false);
      toast.success("Sửa thành công");
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi sửa");
    }
    toast.dismiss(toastUpdate);
  };

  // % khả dụng cho đợt này = 100 − Σ% các đợt khác. Dùng để quy đổi % (tính trên
  // tổng) sang tỉ lệ thanh toán trên "số còn lại": khi % = khả dụng thì thanh toán
  // hết phần còn lại.
  const availablePercent = useMemo(() => {
    const otherSum = (paymentPeriods || [])
      .filter((p) => String(p._id || p.id) !== String(id))
      .reduce((s, p) => s + Number(p.paymentPercent || 0), 0);
    return Math.max(0, 100 - otherSum);
  }, [paymentPeriods, id]);

  useEffect(() => {
    if (lockingManagementData && lockingManagementData.length > 0) {
      setListPaymentService(lockingManagementData);
    } else {
      if (isFake && listEmployee && listEmployee.length > 0) {
        const percent = Number(paymentPercent);
        // % (tính trên tổng) -> tỉ lệ trên số còn lại. % = khả dụng => thanh toán hết.
        const fraction =
          availablePercent > 0 ? Math.min(1, percent / availablePercent) : 0;
        const newList = listEmployee.map((item) => {
          // Giống import: số tiền thanh toán đợt = SỐ CÒN LẠI × tỉ lệ (không phải
          // toàn bộ × %). Hoa hồng & các thành phần suy theo tỉ lệ số tiền / gốc.
          const full = Number(item.remainingRevenueAfterTax || 0); // Tổng PDV sau thuế (gốc)
          const remaining = Number(item.remainingCommission || 0); // Số PDV còn lại
          const amount = remaining * fraction;
          const ratio = full > 0 ? amount / full : 0;
          return {
            id: item.id || item._id || "",
            commissionPrice: (item.commissionPrice || 0) * ratio,
            certificateOrDeposit: (item.certificateOrDeposit || 0) * ratio,
            accountingFromPreviousPeriodOrAdvance:
              (item.accountingFromPreviousPeriodOrAdvance || 0) * ratio,
            remainingRevenueAfterAccounting:
              (item.remainingRevenueAfterAccounting || 0) * ratio,
            personalIncomeTax: (item.personalIncomeTax || 0) * ratio,
            remainingRevenueAfterTax: amount,
            totalRemainingRevenueAfterTax: full,
            bonus: (item.bonus || 0) * ratio,
            employeeObject: item.employeeObject,
            employee: item.employee,
            lockingId: lockingId,
          };
        });

        setListPaymentService(newList);
      }
    }
  }, [lockingManagementData, listEmployee, paymentPercent]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const {
    register,
    control,
    handleSubmit,
    watch,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaPaymentPeriod),
    defaultValues:
      { id, lockingId, period, periodPayment, paymentPercent } || {},
  });

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = useMemo(() => {
    const headers = [
      { label: "", key: "" },
      { label: "STT", key: "" },
      { label: "Mã nhân viên", key: "code" },
      { label: "Tên nhân viên", key: "fullName" },
      { label: "Khối", key: "saleBlock" },
      { label: "Vùng", key: "saleArea" },
      // { label: "Ngày mở đợt thanh toán", key: "createdAt" },
      {
        label: "Tổng PDV sau thuế",
        key: "commissionPrice",
      },
      { label: "PDV TT đợt này", key: "remainingRevenueAfterTax" },
      { label: "PDV còn lại", key: "remainingCommissionPrice" },
      // Tách "PDV TT đợt này" (import): chỉ để theo dõi, không đổi số tiền đợt
      { label: "Số tiền thanh toán PDV", key: "pdvPaidAmount" },
      { label: "Thưởng nóng", key: "hotBonusPaidAmount" },
      { label: "Ghi chú", key: "paymentNote" },
    ];
    const money = (v) =>
      v === null || v === undefined || v === ""
        ? "-"
        : `${Math.round(Number(v) || 0).toLocaleString("en-US")} VNĐ`;

    const data =
      // lockingManagementData && lockingManagementData.length > 0
      //   ? lockingManagementData
      //   :
      listPaymentService.map((item) => ({
        id: item?._id || item?.id || "",
        code: item?.employeeObject?.code || "-",
        fullName: item?.employeeObject?.fullName || "-",
        saleBlock: item?.employee?.saleBlock?.name || item?.saleBlock || "",
        saleArea: item?.employee?.saleArea?.name || item?.saleArea || "",
        // createdAt: item?.createdAt
        //   ? formatDateHourDb(item?.createdAt, 1)
        //   : currentDateHourDb(1),
        commissionPrice:
          Math.round((item?.totalRemainingRevenueAfterTax || 0) * 100) / 100,
        remainingRevenueAfterTax:
          Math.round((item?.remainingRevenueAfterTax || 0) * 100) / 100,
        // PDV còn lại: ưu tiên số lũy kế do BE tính (đã trừ các đợt trước),
        // fallback cho đợt nháp chưa lưu. Làm tròn về đơn vị đồng.
        // Chặn âm do lệch làm tròn 1 đồng (chỉ hiển thị, không đổi dữ liệu).
        remainingCommissionPrice: Math.max(
          0,
          item?.remainingCommissionPrice != null
            ? Math.round(item.remainingCommissionPrice)
            : Math.round(
                (item?.totalRemainingRevenueAfterTax || 0) -
                  (item?.remainingRevenueAfterTax || 0),
              ),
        ),
        pdvPaidAmount: money(item?.pdvPaidAmount),
        hotBonusPaidAmount: money(item?.hotBonusPaidAmount),
        // Import có cột Thưởng nóng: "Thanh toán ... PDV + ... thưởng nóng"
        paymentNote: item?.paymentNote || "-",
      }));

    return { headers, data };
  }, [lockingManagementData, listPaymentService]);

  // Theo dõi giá trị paymentPercent. Gõ % -> điền nhanh số tiền cho từng NV theo
  // SỐ CÒN LẠI × %/100 (giống import: thanh toán % của phần còn lại, không phải
  // toàn bộ). Hoa hồng & các thành phần suy theo tỉ lệ số tiền / gốc.
  const dataChangeRate = (watchPaymentPercent) => {
    const percent = Number(watchPaymentPercent || 0);
    if (percent > 0 && listEmployee.length > 0) {
      // % (tính trên tổng) -> tỉ lệ trên số còn lại. % = khả dụng => thanh toán hết.
      const fraction =
        availablePercent > 0 ? Math.min(1, percent / availablePercent) : 0;
      const newList = listEmployee.map((item) => {
        const full = Number(item.remainingRevenueAfterTax || 0); // Tổng PDV sau thuế (gốc)
        const remaining = Number(item.remainingCommission || 0); // Số PDV còn lại
        const amount = remaining * fraction;
        const ratio = full > 0 ? amount / full : 0;
        return {
          id: item.id || item._id || "",
          remainingRevenueAfterTax: amount,
          commissionPrice: (item.commissionPrice || 0) * ratio,
          certificateOrDeposit: (item.certificateOrDeposit || 0) * ratio,
          accountingFromPreviousPeriodOrAdvance:
            (item.accountingFromPreviousPeriodOrAdvance || 0) * ratio,
          remainingRevenueAfterAccounting:
            (item.remainingRevenueAfterAccounting || 0) * ratio,
          personalIncomeTax: (item.personalIncomeTax || 0) * ratio,
          bonus: (item.bonus || 0) * ratio,
          totalRemainingRevenueAfterTax: full,
          employeeObject: item.employeeObject,
          employee: item.employee,
          lockingId,
        };
      });

      setListPaymentService(newList);
    }
  };

  const submitHandler = async (data, event) => {
    if (isFake) {
      const toastCreate = toast.loading("Đang thêm đợt thanh toán ...");
      try {
        const dataListPaymentService = listPaymentService.map((item) => {
          delete item.id;
          if (item.employeeObject) {
            item.employeeId = item.employeeObject._id;
          }
          delete item.employee;
          delete item.totalRemainingRevenueAfterTax;
          return {
            ...item,
          };
        });

        await stepCommissionCall.createPaymentPeriod({
          lockingId: data.lockingId,
          paymentPercent: data.paymentPercent,
          paymentServiceFee: dataListPaymentService,
        });
        await refetch();
        await refetchParent();
        await getInfomationStepCommission(lockingId);
        toast.success("Thêm thành công");

        // await delay(300);
        // setOpenIndex(Number(paymentPeriods?.length) - 1);
      } catch (error) {
        console.error("Error", error);
        toast.error("Có lỗi xảy ra khi thêm");
      }

      toast.dismiss(toastCreate);

      setTimeout(() => {
        if (accordionRef.current) {
          accordionRef.current.scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      }, 300);
    } else {
      const action = event.nativeEvent.submitter.value; // "edit" hoặc "delete"
      // console.log({ action });
      if (action === "edit") {
        submitEdit(data);
      } else if (action === "delete") {
        submitDelete(data);
      }
    }
  };

  const submitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa đợt thanh toán ...");
    try {
      const { paymentPercent, lockingId, period } = data;
      const dataListPaymentService = listPaymentService.map((item) => {
        delete item.id;
        if (item.employeeObject) {
          item.employeeId = item.employeeObject._id;
          item.lockingId = lockingId;
        }
        delete item.fullName;
        delete item.code;
        delete item.saleArea;
        delete item.saleBlock;
        delete item.employee;
        delete item.status;
        // Các field chỉ để hiển thị, không thuộc schema paymentServiceFee ->
        // bỏ đi để API không báo "is not allowed" (và tránh ghi rác vào DB).
        delete item.totalRemainingRevenueAfterTax;
        delete item.remainingCommissionPrice;
        delete item.monthYearBreakdown;
        delete item.createdAt;
        delete item.paymentNote;
        delete item.pdvPaidAmount;
        delete item.hotBonusPaidAmount;
        return {
          ...item,
        };
      });
      if (isFake) {
        const updatedList = listPaymentService.filter((item) => item.id !== id);
        setListPaymentService(updatedList);
      } else {
        await stepCommissionCall.updatePaymentPeriod(id, {
          paymentPercent,
          paymentServiceFee: dataListPaymentService,
        });
        await refetch();
        await refetchParent();
        await getInfomationStepCommission(lockingId, period);
        toast.success("Sửa thành công");
      }
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi sửa");
    }

    toast.dismiss(toastCreate);
  };

  const submitDelete = async (data) => {
    // console.log({ data });

    const toastCreate = toast.loading("Đang xóa đợt thanh toán ...");
    try {
      if (isFake) {
        const updatedList = listPaymentService.filter(
          (item) => item.id !== data.id,
        );
        // console.log(id);
        setListPaymentService(updatedList);
        deleteHandler(id, true);
        await refetch();
        toast.success("Xóa thành công");
      } else {
        const { id, lockingId, period } = data;

        await stepCommissionCall.deletePaymentPeriod(id);
        await refetchParent();
        await getInfomationStepCommission(lockingId, period);
        toast.success("Xóa thành công");
      }
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }

    toast.dismiss(toastCreate);
  };

  const onSubmitDelete = async () => {
    const data = getValues();
    await submitDelete(data);
    onClose();
  };

  const submitEditData = (type, id, value, key) => {
    setDataEdit({ type, id, value, key });
    updateParticipantValue(id, key, value);
    onOpenEditPrice();
  };

  function updateParticipantValue(id, key, value) {
    console.log({ id, key, value });
    const lockingRelativeParticipantNew = listPaymentService.map((item) => {
      //   console.log(item);
      if (item.id === id || item.employeeObject?._id === id) {
        return {
          ...item,
          [key]: value,
          status: true,
        };
      }
      return item;
    });
    console.log({ lockingRelativeParticipantNew });
    setListPaymentService(lockingRelativeParticipantNew);
    onCloseEditPrice();
  }

  console.log({ step });
  return (
    <>
      <Box w={"100%"}>
        {/* Nội dung của panel */}
        <form onSubmit={handleSubmit(submitHandler)}>
          <Box mb={4}>
            {isEditInfo ? (
              // Chặn Enter trong ô ngày/tháng submit nhầm form "Sửa" đợt.
              <Flex
                gap={"16px"}
                alignItems={"flex-end"}
                flexWrap={"wrap"}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
              >
                <Box w={"200px"}>
                  {/* zIndex: lịch bật ra phải nằm trên ô "Phần trăm thanh toán",
                      ô tìm kiếm và bảng bên dưới; ô đang mở lịch được ưu tiên. */}
                  <InputDatePicker
                    label="Ngày thanh toán"
                    zIndex={focusStates["infoDate"] ? 4 : 3}
                    focusStates={focusStates["infoDate"]}
                    formLabelStyle={{
                      fontSize: "12px",
                      lineHeight: "15px",
                      mb: "6px",
                      fontWeight: 400,
                    }}
                    selected={infoDate}
                    onChange={(date) => setInfoDate(date)}
                    onFocus={() => handleFocus("infoDate")}
                    onBlur={() => handleBlur("infoDate")}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    placeholderText="Chọn ngày"
                    popperProps={{ strategy: "fixed" }}
                  />
                </Box>
                {infoMonths.map((m, index) => (
                  <Box w={"160px"} key={index}>
                    <InputDatePicker
                      label={
                        infoMonths.length > 1 ? `Tháng ĐC (${m.from})` : "Tháng ĐC"
                      }
                      zIndex={focusStates[`infoMonth${index}`] ? 4 : 3}
                      focusStates={focusStates[`infoMonth${index}`]}
                      formLabelStyle={{
                        fontSize: "12px",
                        lineHeight: "15px",
                        mb: "6px",
                        fontWeight: 400,
                      }}
                      selected={m.to}
                      onChange={(date) =>
                        setInfoMonths((prev) =>
                          prev.map((x, i) => (i === index ? { ...x, to: date } : x)),
                        )
                      }
                      onFocus={() => handleFocus(`infoMonth${index}`)}
                      onBlur={() => handleBlur(`infoMonth${index}`)}
                      showMonthYearPicker
                      dateFormat="MM/yyyy"
                      locale="vi"
                      placeholderText="Chọn tháng"
                      popperProps={{ strategy: "fixed" }}
                    />
                  </Box>
                ))}
                <Button
                  h={"44px"}
                  p={"10px 16px"}
                  backgroundImage="var(--color-button)"
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  type="button"
                  onClick={submitEditInfo}
                >
                  <Text
                    fontSize={{ base: "15px" }}
                    fontWeight={600}
                    color="var(--color-main)"
                  >
                    Lưu
                  </Text>
                </Button>
                <Button
                  h={"44px"}
                  p={"10px 16px"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  bg={"var(--color-main)"}
                  _hover={{
                    filter: "brightness(95%)",
                  }}
                  type="button"
                  onClick={() => setIsEditInfo(false)}
                >
                  <Text
                    fontSize={{ base: "15px" }}
                    fontWeight={600}
                    color="var(--color-option-employee-hover)"
                  >
                    Hủy
                  </Text>
                </Button>
              </Flex>
            ) : (
              <>
                <Flex alignItems={"center"} gap={"8px"} mb={"6px"}>
                  <Text
                    lineHeight={"15px"}
                    m="0"
                    fontSize={{ base: "12px" }}
                    fontWeight={400}
                    color={"var(--color-option-employee-hover)"}
                  >
                    Ngày thanh toán
                  </Text>
                  {!isFake && (
                    <Image
                      src={iconEdit}
                      w={"16px"}
                      h={"16px"}
                      cursor={"pointer"}
                      title="Sửa ngày thanh toán, tháng đối chiếu"
                      onClick={openEditInfo}
                    />
                  )}
                </Flex>

                <Text
                  fontSize={{ base: "14px" }}
                  lineHeight={"17px"}
                  fontWeight={"500"}
                >
                  {step?.disbursementDate
                    ? formatDateDb(step?.disbursementDate)
                    : step?.createdAt
                      ? formatDateDb(step?.createdAt)
                      : currentformatDateDb()}
                  {step?.monthYears?.length
                    ? ` - Tháng ĐC: ${step.monthYears.join(", ")}`
                    : ""}
                </Text>
              </>
            )}
          </Box>

          <Flex
            justifyContent="space-between"
            alignItems={"center"}
            w={"full"}
            mb={4}
          >
            <Box>
              <InputControl
                type="number"
                label="Phần trăm thanh toán"
                placeholder="Nhập phần trăm thanh toán VD: 30"
                errors={errors.paymentPercent}
                register={register("paymentPercent")}
                onFocus={() => handleFocus("paymentPercent")}
                onBlur={() => handleBlur("paymentPercent")}
                state={focusStates["paymentPercent"]}
                onlyPositiveNumbers={true}
                defaultValue={paymentPercent}
                isRate={true}
                onChangeData={() => {
                  dataChangeRate(watch("paymentPercent"));
                }}
              />
            </Box>

            <Flex gap={4} alignItems={"center"}>
              <Button
                w={"176px"}
                h={"44px"}
                display={"flex"}
                alignItems={"center"}
                p={"10px 16px 10px 12px"}
                gap={"8px"}
                backgroundImage="var(--color-button)"
                _hover={{
                  filter: "brightness(90%)",
                }}
                type="submit"
                name="action"
                value="edit"
              >
                <Text
                  fontSize={{ base: "15px" }}
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  {isFake ? "Xác nhận" : "Sửa"}
                </Text>
              </Button>
              {/* <Button
                w={"176px"}
                h={"44px"}
                display={"flex"}
                alignItems={"center"}
                p={"10px 16px 10px 12px"}
                gap={"8px"}
                bg="red.500"
                _hover={{
                  filter: "brightness(90%)",
                }}
                type="button"
                onClick={onOpen}
              >
                <Text
                  fontSize={{ base: "15px" }}
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  Xóa
                </Text>
              </Button> */}
            </Flex>
          </Flex>
        </form>
        <Flex flexDirection={"column"} gap={{ base: "16px" }} mb={"20px"}>
          <Flex
            backgroundColor="var(--color-main)"
            borderRadius={{ base: "12px" }}
            flexDirection={"column"}
          >
            <Flex w={"full"} p={"16px 16px 12px 16px"}>
              <Text
                fontSize={"16px"}
                lineHeight={"19px"}
                fontWeight={"600"}
                color={"var(--color-header-employee)"}
              >
                Danh sách nhân viên
              </Text>
            </Flex>
            <Flex
              alignItems={"center"}
              justifyContent={"space-between"}
              gap={{ base: "32px" }}
              p={"16px 16px 12px 16px"}
            >
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                p={"16px 0px 12px 16px"}
                flexWrap={"wrap"}
              >
                <InputGroup
                  maxW="42vw"
                  minW={"42vw"}
                  borderRadius={{ base: "8px" }}
                  w={{ base: "100%" }}
                >
                  <Input
                    placeholder="Tên, mã nhân viên "
                    type="text"
                    borderRadius={{ base: "8px" }}
                    border={{ base: "1px solid var(--color-boder)" }}
                    backgroundColor={"var(--fill-avatar)"}
                    onChange={onChangeSearch}
                  />
                  <InputRightElement
                    borderTopRightRadius={"8px"}
                    borderBottomRightRadius={"8px"}
                    pointerEvents="none"
                    cursor={"pointer"}
                    backgroundImage="var(--color-button)"
                  >
                    <SearchIcon color="var(--color-main)" />
                  </InputRightElement>
                </InputGroup>
              </Flex>
            </Flex>
            <Box width={"100%"} height={"100%"}>
              <Skeleton isLoaded={!isLoading && !isRefetching}>
                <TableContainer
                  w={"100%"}
                  maxH="calc(100vh - 350.5px)"
                  overflowY="auto"
                >
                  <Table w={"100%"} variant="unstyled">
                    <Thead
                      position="sticky"
                      top="0"
                      zIndex="1"
                      w={"100%"}
                      h={"41px"}
                      color="white"
                      fontWeight="400"
                      backgroundColor="#F9FAFD"
                    >
                      <Tr h={{ base: "41px" }}>
                        {tableData.headers.map((e, index) => {
                          let width = "auto";
                          let textAlign = "start";
                          if (e.key === "") {
                            width = "2%";
                            textAlign = "start";
                          } else if (e.key === "code") {
                            width = "5%";
                            textAlign = "start";
                          } else if (e.key === "fullName") {
                            width = "5%";
                            textAlign = "start";
                          } else if (e.key === "commissionPrice") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "remainingRevenueAfterTax") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "saleBlock") {
                            width = "10%";
                            textAlign = "start";
                          } else if (e.key === "saleArea") {
                            width = "10%";
                            textAlign = "start";
                          } else {
                            width = "10%";
                            textAlign = "start";
                          }
                          return (
                            <Td
                              p={"16px 16px 8px 16px"}
                              key={index}
                              border={"none"}
                              color={"#51607B"}
                              fontSize={{ base: "14px" }}
                              w={width}
                            >
                              <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                            </Td>
                          );
                        })}
                      </Tr>
                    </Thead>
                    <Tbody w={"100%"} h={"100%"}>
                      {tableData.data?.length > 0 ? (
                        tableData.data?.map((e, rowIndex) => {
                          const items = { ...e };
                          delete items.id;
                          delete items.lockingId;
                          delete items.status;
                          const keyValues = Object.keys(items);
                          return (
                            <Tr key={rowIndex} h={"72px"}>
                              <Td p={"16px 16px 8px 16px"} w={"2%"}>
                                <Menu>
                                  <MenuButton
                                    _hover={{ backgroundColor: "none" }}
                                    _active={{ backgroundColor: "none" }}
                                    background="none"
                                    as={Button}
                                  >
                                    <AiOutlineMore fontSize={"20px"} />
                                  </MenuButton>
                                  <MenuList>
                                    <MenuItem
                                      onClick={() => {
                                        const raw = listPaymentService.find(
                                          (x) => (x._id || x.id) === e.id,
                                        );
                                        setBreakdownInfo({
                                          code: e.code,
                                          fullName: e.fullName,
                                          breakdown: raw?.monthYearBreakdown || [],
                                        });
                                        onOpenBreakdown();
                                      }}
                                    >
                                      Chi tiết theo tháng đối chiếu
                                    </MenuItem>
                                    {/* Chỉ cho xoá dòng đã lưu (có id thật) và khi
                                        đợt chưa xác nhận chuyển khoản. */}
                                    {!isFake && !step?.isPayment && e?.id ? (
                                      <MenuItem
                                        color={"red.500"}
                                        onClick={() => {
                                          setFeeToDelete({
                                            id: e.id,
                                            code: e.code,
                                            fullName: e.fullName,
                                          });
                                          onOpenDeleteFee();
                                        }}
                                      >
                                        Xóa nhân viên khỏi đợt
                                      </MenuItem>
                                    ) : null}
                                  </MenuList>
                                </Menu>
                              </Td>
                              <Td p={"16px 16px 8px 16px"} w={"2%"}>
                                {rowIndex + 1}
                              </Td>
                              {keyValues.map((keyvalue, index) => {
                                let width = "auto";
                                let widthText = "100%";
                                let textAlign = "start";
                                let whiteSpace = "inherit";
                                if (keyvalue === "") {
                                  width = "2%";
                                  textAlign = "start";
                                } else if (keyvalue === "code") {
                                  width = "5%";
                                  textAlign = "start";
                                } else if (keyvalue === "fullName") {
                                  width = "5%";
                                  textAlign = "start";
                                } else if (keyvalue === "commissionPrice") {
                                  width = "15%";
                                  textAlign = "start";
                                } else if (
                                  keyvalue === "remainingRevenueAfterTax"
                                ) {
                                  width = "15%";
                                  textAlign = "start";
                                } else if (keyvalue === "saleBlock") {
                                  width = "10%";
                                  textAlign = "start";
                                } else if (keyvalue === "saleArea") {
                                  width = "10%";
                                  textAlign = "start";
                                } else {
                                  width = "10%";
                                  textAlign = "start";
                                  whiteSpace = "inherit";
                                }
                                return (
                                  <Td
                                    p={"16px 16px 8px 16px"}
                                    w={width}
                                    key={index}
                                  >
                                    <Box
                                      fontSize={{ base: "14px" }}
                                      lineHeight={"19.6px"}
                                      textAlign={"start"}
                                      fontWeight={500}
                                      color={"var(--color-info-employee)"}
                                      w={widthText}
                                      whiteSpace={whiteSpace}
                                      overflow="hidden"
                                      textOverflow="ellipsis"
                                      display="-webkit-box"
                                      sx={{
                                        WebkitLineClamp: "2",
                                        WebkitBoxOrient: "vertical",
                                      }}
                                    >
                                      {keyvalue === "workingDays" ||
                                      "isBrokerDebtCertificate" ||
                                      "remainingRevenueAfterTax"
                                        ? formatTableValue(
                                            e[keyvalue],
                                            keyvalue,
                                            submitEditData,
                                            e?.id || e?.employeeObject?._id,
                                            true,
                                          )
                                        : formatTableValue(
                                            e[keyvalue],
                                            keyvalue,
                                          )}
                                    </Box>
                                  </Td>
                                );
                              })}
                            </Tr>
                          );
                        })
                      ) : (
                        <Tr>
                          <Td
                            colSpan={tableData.headers.length}
                            textAlign="center"
                            padding={"40px 0"}
                          >
                            Không có dữ liệu
                          </Td>
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Skeleton>
              <Box mt={10} mr={5} mb={5} ml={5}>
                <Flex alignItems={"center"} justifyContent={"space-between"}>
                  <Text>
                    Showing {startEntry} to {endEntry} of {entries} entries
                  </Text>
                  <HStack spacing={2} justify="flex-end">
                    <ReactPaginate
                      className="pagination-custom"
                      pageCount={totalPages}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      breakClassName={"ellipsis"}
                      breakLabel={"..."}
                      previousLabel={
                        <Img
                          w={"16px"}
                          minW={"16px"}
                          h={"16px"}
                          src={chevronLeft}
                        />
                      }
                      nextLabel={
                        <Img
                          w={"16px"}
                          minW={"16px"}
                          h={"16px"}
                          src={chevronRight}
                        />
                      }
                      renderOnZeroPageCount={null}
                      forcePage={currentPage - 1}
                    />
                  </HStack>
                </Flex>
              </Box>
            </Box>
          </Flex>
        </Flex>
      </Box>

      <DeleteDialog
        isOpen={isOpen}
        onClose={onClose}
        title={"Xóa khách hàng"}
        description={
          <Flex display={"inline"}>
            "Bạn có chắc chắn muốn xóa đợt thanh toán{" "}
            <Text fontWeight={"600"} display={"inline"}>
              {periodPayment}
            </Text>{" "}
            không?"
          </Flex>
        }
        action={() => onSubmitDelete()}
      />

      <DeleteDialog
        isOpen={isOpenDeleteFee}
        onClose={() => {
          onCloseDeleteFee();
          setFeeToDelete(null);
        }}
        title={"Xóa nhân viên khỏi đợt thanh toán"}
        description={
          <Flex display={"inline"}>
            Bạn có chắc chắn muốn xóa nhân viên{" "}
            <Text fontWeight={"600"} display={"inline"}>
              {feeToDelete?.code} - {feeToDelete?.fullName}
            </Text>{" "}
            khỏi đợt thanh toán{" "}
            <Text fontWeight={"600"} display={"inline"}>
              {periodPayment}
            </Text>{" "}
            không? Số tiền của đợt và số PDV còn lại sẽ được tính lại.
          </Flex>
        }
        action={() => onSubmitDeleteFee()}
      />

      <Modal isOpen={isOpenBreakdown} onClose={onCloseBreakdown} isCentered>
        <ModalOverlay />
        <ModalContent maxW="560px">
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            p={"20px 24px"}
            borderBottom={"1px solid var(--color-boder)"}
          >
            <Box>
              <Text fontSize={"16px"} fontWeight={600}>
                Chi tiết theo tháng đối chiếu
              </Text>
              <Text fontSize={"13px"} color={"var(--color-label-employee)"}>
                {breakdownInfo?.fullName} ({breakdownInfo?.code})
              </Text>
            </Box>
            <Image src={IconX} cursor={"pointer"} onClick={onCloseBreakdown} />
          </Flex>
          <Box p={"16px 24px 24px"}>
            {breakdownInfo?.breakdown?.length > 0 ? (
              <Table variant="simple" size="sm">
                <Thead>
                  <Tr>
                    <Td fontWeight={600}>Tháng ĐC</Td>
                    <Td fontWeight={600} textAlign="end">
                      Số tiền thanh toán
                    </Td>
                    <Td fontWeight={600} textAlign="end">
                      Hoa hồng
                    </Td>
                  </Tr>
                </Thead>
                <Tbody>
                  {breakdownInfo.breakdown.map((b, i) => (
                    <Tr key={i}>
                      <Td>
                        {String(b.month).padStart(2, "0")}/{b.year}
                      </Td>
                      <Td textAlign="end">{formatPriceUS(b.amount || 0)} VNĐ</Td>
                      <Td textAlign="end">
                        {formatPriceUS(b.commissionPrice || 0)} VNĐ
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            ) : (
              <Text fontSize={"14px"} color={"var(--color-label-employee)"}>
                Không có breakdown theo tháng đối chiếu (đợt tạo thủ công hoặc
                chưa import theo tháng).
              </Text>
            )}
          </Box>
        </ModalContent>
      </Modal>

      {/* <FormEdit
        isOpen={isOpenEditPrice}
        onClose={onCloseEditPrice}
        defaultValues={dataEdit}
        onSubmit={updateParticipantValue}
      /> */}
    </>
  );
}

const FormEdit = memo(({ isOpen, onClose, onSubmit, defaultValues }) => {
  let schema = Yup.object().shape({});
  if (defaultValues?.type === "NUMBER") {
    schema = Yup.object().shape({
      value: Yup.number()
        .transform((value, originalValue) => {
          if (
            typeof originalValue === "string" &&
            originalValue.trim() === ""
          ) {
            return null;
          }
          return Number(originalValue);
        })
        .typeError("Tổng số quỹ giữ phải là một số hợp lệ")
        // .moreThan(0, "Tổng số quỹ giữ phải lớn hơn 0")
        .required("Vui lòng nhập tổng số quỹ giữ"),
    });
  }
  const CCMGData = [
    {
      value: 1,
      label: "Đã có",
    },
    {
      value: 2,
      label: "Chưa có",
    },
  ];

  const {
    setValue,
    reset,
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues?.value
      ? {
          value:
            defaultValues?.type === "CHECKED"
              ? defaultValues?.value
                ? 1
                : 2
              : defaultValues?.value,
        }
      : {},
  });

  const [focusedIndex, setFocusedIndex] = useState(null);
  const [focusStates, setFocusStates] = useState({});
  const [displayPrice, setDisplayPrice] = useState(0);

  const onChangePrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9.]/g, "");
      setDisplayPrice(formatNumberUS(Number(numericValue)));
      setValue("value", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatNumberUS],
  );

  useEffect(() => {
    reset(
      defaultValues?.type === "CHECKED"
        ? { value: defaultValues?.value ? 1 : 2 }
        : { value: defaultValues?.value ?? "" },
    );

    if (
      defaultValues?.value &&
      defaultValues?.key === "remainingRevenueAfterTax"
    ) {
      setDisplayPrice(formatNumberUS(defaultValues?.value || 0));
    } else if (defaultValues?.value && defaultValues?.type === "CHECKED") {
      setValue("value", defaultValues?.value ? 1 : 2);
    } else {
      setDisplayPrice(formatNumberUS(0));
    }
  }, [isOpen]);

  const handleFocus = (field, index) => {
    if (index !== null) {
      setFocusedIndex(index);
    } else {
      setFocusStates((prev) => ({ ...prev, [field]: true }));
    }
  };

  const handleBlur = (field, index) => {
    if (index !== null) {
      setFocusedIndex(index);
    } else {
      setFocusedIndex(null);
    }
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const onchangeCCMG = (option) => {
    setValue("value", option);
  };

  const submitHandler = (data) => {
    if (defaultValues?.id) {
      data.employeeId = defaultValues?.id;
    }

    if (defaultValues?.key) {
      data.key = defaultValues?.key;
    }

    if (defaultValues?.type === "CHECKED") {
      data.value = data.value === 1 ? true : false;
    }

    onSubmit(data);
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
      >
        <form onSubmit={handleSubmit(submitHandler)}>
          <Box
            // paddingBottom={"80px"}
            w={"100%"}
            overflowY={"scroll"}
          >
            <Flex
              alignItems={"center"}
              p={"25px 24px 24px 24px"}
              position={"relative"}
              borderBottom={"1px solid var(--border-input-employee)"}
            >
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Chỉnh sửa dữ liệu
              </Text>
              <Box
                position={"absolute"}
                top={"24px"}
                right={"24px"}
                cursor={"pointer"}
                onClick={onClose}
              >
                <Image src={IconX} />
              </Box>
            </Flex>
            <Box margin={"0 auto"}>
              <Box flex={1} p={"24px 24px 40px 40px"}>
                {defaultValues?.type === "NUMBER" &&
                  defaultValues?.key === "remainingRevenueAfterTax" && (
                    <InputControl
                      // type="number"
                      label="Tổng số quỹ giữ"
                      placeholder="Nhập tổng số quỹ còn giữ"
                      errors={errors.value}
                      register={register("value")}
                      onFocus={() => handleFocus("value")}
                      onBlur={() => handleBlur("value")}
                      state={focusStates["value"]}
                      onChange={onChangePrice}
                      value={displayPrice}
                      mwidth={"100%"}
                      // isRequired={true}
                    />
                  )}

                {defaultValues?.type === "NUMBER" &&
                  defaultValues?.key === "workingDays" && (
                    <InputControl
                      type="number"
                      label="Số công"
                      placeholder="Nhập số công"
                      errors={errors.value}
                      register={register("value")}
                      onFocus={() => handleFocus("value")}
                      onBlur={() => handleBlur("value")}
                      state={focusStates["value"]}
                      value={watch("value")}
                      mwidth={"100%"}
                      // isRequired={true}
                    />
                  )}

                {defaultValues?.type === "CHECKED" &&
                  defaultValues?.key === "isBrokerDebtCertificate" && (
                    <SelectControl
                      label="Đã có CCMG"
                      dataOption={CCMGData}
                      selectedMain={watch("value")}
                      placeholder="Chọn trạng thái CCMG"
                      onChange={onchangeCCMG}
                      onFocus={() => handleFocus("value")}
                      onBlur={() => handleBlur("value")}
                      state={focusStates["value"]}
                      registerProps={register("value")}
                    />
                  )}
              </Box>
            </Box>
            <Box
              // position={"absolute"}
              w={"100%"}
              // bottom={"0"}
              bg={"var(--color-main)"}
              borderTop={"0.5px solid var(--bg-line-employee)"}
              borderRadius={"0px 0px 16px 16px"}
              zIndex={3}
            >
              <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                <Button
                  w={"112px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-option-employee-hover)"}
                  borderRadius={"8px"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  bg={"var(--color-main)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                  onClick={onClose}
                >
                  Hủy
                </Button>
                <Button
                  type="submit"
                  w={"112px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  bg={"var(--color-option-employee-hover)"}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Lưu
                </Button>
              </Flex>
            </Box>
          </Box>
        </form>
      </ModalContent>
    </Modal>
  );
});
